export default __webpack_public_path__ + "static/reviews-principal-2347c64a83c9f3642720e8126e3c54bd.png";